import { render, staticRenderFns } from "./MoleculeAvailabilityFilterStatistics.vue?vue&type=template&id=67cd9b82&"
import script from "./MoleculeAvailabilityFilterStatistics.vue?vue&type=script&lang=js&"
export * from "./MoleculeAvailabilityFilterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAvailabilityFilterStatistics.vue?vue&type=style&index=0&id=67cd9b82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeAvailabilityFilterStatistics.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeAvailabilityFilterStatistics.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAtomLoader: require('/app/components/atoms/AtomLoader.vue').default})
